// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bodhiwell · FAQ de perfil profesional
   Componente aislado y sin dependencias.
   Hereda los tokens del manual y declara fallbacks seguros. */

.bw-profile-faq,
.bw-faq-editor {
  --bw-faq-bg: var(--bg-surface, #F7F5F1);
  --bw-faq-bg-soft: #FBFAF7;
  --bw-faq-text: var(--text-main, #13231D);
  --bw-faq-muted: var(--text-muted, #5F726B);
  --bw-faq-primary: var(--primary, #82B194);
  --bw-faq-primary-hover: var(--primary-hover, #739F84);
  --bw-faq-border: var(--border-soft, rgba(19,35,29,.08));
  --bw-faq-card-radius: var(--radius-card, 32px);
  --bw-faq-item-radius: 22px;
  --bw-faq-shadow: var(--shadow-soft, 0 18px 48px rgba(18,34,29,.04));
  color: var(--bw-faq-text);
  font-family: "Sora", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  box-sizing: border-box;
}

.bw-profile-faq *,
.bw-faq-editor * { box-sizing: border-box; }

/* =========================
   VISTA PÚBLICA
========================= */
.bw-profile-faq {
  padding: 28px 30px;
  border: 1px solid var(--bw-faq-border);
  border-radius: var(--bw-faq-card-radius);
  background: var(--bw-faq-bg);
  box-shadow: var(--bw-faq-shadow);
}

.bw-profile-faq[hidden] { display: none !important; }

.bw-profile-faq__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}

.bw-profile-faq__header > div {
  flex: 1 1;
}

.bw-profile-faq__title {
  margin: 0;
  color: var(--bw-faq-text);
  font-size: 30px;
  line-height: 1.08;
  letter-spacing: -.04em;
  font-weight: 800;
}

.bw-profile-faq__intro {
  margin: 7px 0 0;
  max-width: 62ch;
  color: var(--bw-faq-muted);
  font-size: 13px;
  line-height: 1.55;
}

.bw-profile-faq__edit-btn {
  display: inline-flex;
  align-items: center;
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid rgba(130,177,148,.32);
  border-radius: 12px;
  background: rgba(130,177,148,.09);
  color: #315342;
  font-size: 11px;
  font-weight: 800;
  text-decoration: none;
  flex-shrink: 0;
  transition: all 0.2s;
}

.bw-profile-faq__edit-btn:hover {
  background: rgba(130,177,148,.16);
  border-color: rgba(130,177,148,.45);
}

.bw-profile-faq__list {
  display: grid;
  gap: 9px;
}

.bw-profile-faq__item {
  overflow: hidden;
  border: 1px solid var(--bw-faq-border);
  border-radius: 16px;
  background: rgba(255, 255, 255, .45);
  transition: border-color .2s ease, background-color .2s ease;
}

.bw-profile-faq__item[open] {
  border-color: rgba(130, 177, 148, .42);
  background: rgba(130, 177, 148, .055);
}

.bw-profile-faq__question {
  list-style: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  width: 100%;
  padding: 16px 18px;
  color: var(--bw-faq-text);
  font-size: 14px;
  font-weight: 750;
  text-align: left;
  border: 0;
  background: transparent;
}

.bw-profile-faq__question::-webkit-details-marker { display: none; }

.bw-profile-faq__question:focus-visible {
  outline: 3px solid rgba(130,177,148,.25);
  outline-offset: -3px;
}

.bw-profile-faq__icon {
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(130,177,148,.30);
  border-radius: 50%;
  background: transparent;
  color: #5E806C;
  font-size: 18px;
  transition: transform .2s ease, background-color .2s ease, color .2s ease;
}

.bw-profile-faq__item[open] .bw-profile-faq__icon {
  transform: rotate(45deg);
  background: var(--bw-faq-primary);
  color: #fff;
  border-color: var(--bw-faq-primary);
}

.bw-profile-faq__answer { 
  display: grid;
}

.bw-profile-faq__answer p {
  margin: 0;
  padding: 0 58px 17px 18px;
  max-width: 78ch;
  color: var(--bw-faq-muted);
  font-size: 13px;
  line-height: 1.7;
  white-space: pre-line;
}

/* =========================
   EDITOR PROFESIONAL
========================= */
.bw-faq-editor {
  position: relative;
  padding: 28px 30px 104px;
  border: 1px solid var(--bw-faq-border);
  border-radius: var(--bw-faq-card-radius);
  background: var(--bw-faq-bg);
  box-shadow: var(--bw-faq-shadow);
}

.bw-faq-editor__heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}

.bw-faq-editor__title {
  margin: 0;
  color: var(--bw-faq-text);
  font-size: clamp(26px, 3vw, 36px);
  line-height: 1.08;
  letter-spacing: -.045em;
  font-weight: 800;
}

.bw-faq-editor__intro {
  margin: 9px 0 0;
  max-width: 720px;
  color: var(--bw-faq-muted);
  font-size: 14px;
  line-height: 1.7;
}

.bw-faq-editor__count {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  min-height: 30px;
  padding: 0 10px;
  border: 1px solid rgba(130,177,148,.26);
  border-radius: 999px;
  background: rgba(130,177,148,.09);
  color: #5E806C;
  font-size: 11px;
  font-weight: 800;
}

.bw-faq-editor__ideas {
  margin-top: 22px;
  padding: 18px 20px;
  border: 1px solid rgba(130,177,148,.22);
  border-radius: 18px;
  background: rgba(130,177,148,.07);
}

.bw-faq-editor__ideas h3 {
  margin: 0 0 8px;
  font-size: 15px;
}

.bw-faq-editor__ideas p {
  margin: 0 0 12px;
  color: var(--bw-faq-muted);
  font-size: 12px;
  line-height: 1.6;
}

.bw-faq-editor__idea-list {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.bw-faq-editor__idea {
  padding: 7px 10px;
  border: 1px solid rgba(130,177,148,.22);
  border-radius: 999px;
  background: rgba(255,255,255,.55);
  color: #4D6258;
  font-size: 11px;
}

.bw-faq-editor__list {
  display: grid;
  gap: 14px;
  margin-top: 20px;
}

.bw-faq-editor__empty {
  padding: 24px;
  border: 1px dashed rgba(19,35,29,.16);
  border-radius: 18px;
  color: var(--bw-faq-muted);
  text-align: center;
  font-size: 13px;
  line-height: 1.65;
}

.bw-faq-editor__item {
  position: relative;
  padding: 18px;
  border: 1px solid var(--bw-faq-border);
  border-radius: 20px;
  background: rgba(255,255,255,.45);
  transition: opacity .2s ease, border-color .2s ease;
}

.bw-faq-editor__item.is-hidden { opacity: .68; }
.bw-faq-editor__item.has-error { border-color: rgba(176,78,69,.42); }

.bw-faq-editor__item-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 15px;
}

.bw-faq-editor__number {
  margin-right: auto;
  color: #5F6E68;
  font-size: 12px;
  font-weight: 800;
}

.bw-faq-editor__actions {
  display: flex;
  align-items: center;
  gap: 7px;
}

.bw-faq-editor__icon-btn {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  border: 1px solid var(--bw-faq-border);
  border-radius: 10px;
  background: #FFF;
  color: #65736D;
  font-size: 13px;
  cursor: pointer;
}

.bw-faq-editor__icon-btn:hover:not(:disabled),
.bw-faq-editor__icon-btn:focus-visible {
  border-color: rgba(130,177,148,.48);
  color: #5E806C;
}

.bw-faq-editor__icon-btn:disabled { opacity: .35; cursor: default; }

.bw-faq-editor__icon-btn--delete {
  color: #C95C5C;
  background: #FEF2F2;
  border: 1px solid rgba(201, 92, 92, 0.4);
}

.bw-faq-editor__icon-btn--delete:hover:not(:disabled),
.bw-faq-editor__icon-btn--delete:focus-visible {
  background: #C95C5C;
  color: #fff;
  border-color: transparent;
}

.bw-faq-editor__toggle-label {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #5A6B64;
  font-size: 11px;
  font-weight: 700;
}

.bw-faq-editor__switch {
  position: relative;
  width: 36px;
  height: 20px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: #CFD7D2;
  cursor: pointer;
}

.bw-faq-editor__switch::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #FFF;
  box-shadow: 0 1px 4px rgba(0,0,0,.15);
  transition: left .2s ease;
}

.bw-faq-editor__switch[aria-checked="true"] { background: var(--bw-faq-primary); }
.bw-faq-editor__switch[aria-checked="true"]::after { left: 19px; }

.bw-faq-editor__field { display: block; }
.bw-faq-editor__field + .bw-faq-editor__field { margin-top: 14px; }

.bw-faq-editor__label {
  display: block;
  margin-bottom: 7px;
  color: #6D7C75;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: .08em;
  text-transform: uppercase;
}

.bw-faq-editor__input,
.bw-faq-editor__textarea {
  display: block;
  width: 100%;
  border: 1px solid rgba(19,35,29,.10);
  border-radius: 13px;
  background: #FFF;
  color: var(--bw-faq-text);
  outline: none;
  font: inherit;
}

.bw-faq-editor__input { height: 44px; padding: 0 13px; }
.bw-faq-editor__textarea { min-height: 112px; padding: 12px 13px; resize: vertical; line-height: 1.55; }

.bw-faq-editor__input:focus,
.bw-faq-editor__textarea:focus {
  border-color: rgba(130,177,148,.62);
  box-shadow: 0 0 0 3px rgba(130,177,148,.10);
}

.bw-faq-editor__input[aria-invalid="true"],
.bw-faq-editor__textarea[aria-invalid="true"] { border-color: rgba(176,78,69,.52); }

.bw-faq-editor__field-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 6px;
  color: #8B9691;
  font-size: 10px;
}

.bw-faq-editor__error { color: #A6534B; }

.bw-faq-editor__bottom-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 16px;
}

.bw-faq-editor__add {
  min-height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
  border: 1px solid rgba(130,177,148,.42);
  border-radius: 13px;
  background: rgba(130,177,148,.10);
  color: #315442;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
}

.bw-faq-editor__add:disabled { opacity: .45; cursor: not-allowed; }
.bw-faq-editor__limit { color: #7A8882; font-size: 11px; }

.bw-faq-editor__save-wrap {
  position: absolute;
  left: 22px;
  right: 22px;
  bottom: 18px;
}

.bw-faq-editor__save-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 13px 14px;
  border: 1px solid var(--bw-faq-border);
  border-radius: 18px;
  background: rgba(247,245,241,.96);
  box-shadow: 0 12px 32px rgba(19,35,29,.10);
  backdrop-filter: blur(10px);
}

.bw-faq-editor__save-state { display: flex; align-items: center; gap: 10px; }
.bw-faq-editor__save-dot { width: 9px; height: 9px; border-radius: 50%; background: var(--bw-faq-primary); }
.bw-faq-editor__save-copy { font-size: 12px; font-weight: 800; }
.bw-faq-editor__save-sub { margin-top: 2px; color: #718079; font-size: 10px; }
.bw-faq-editor__save-actions { display: flex; gap: 8px; }

.bw-faq-editor__button {
  min-height: 38px;
  padding: 0 16px;
  border: 1px solid rgba(130,177,148,.34);
  border-radius: 12px;
  background: #FFF;
  color: var(--bw-faq-text);
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
}

.bw-faq-editor__button--primary {
  min-width: 118px;
  border-color: var(--bw-faq-primary);
  background: var(--bw-faq-primary);
  color: #FFF;
}

.bw-faq-editor__button:disabled { opacity: .48; cursor: not-allowed; }

.bw-faq-editor__toast {
  position: fixed;
  left: 50%;
  bottom: 24px;
  z-index: 100;
  transform: translate(-50%,20px);
  padding: 11px 16px;
  border-radius: 12px;
  background: #13231D;
  color: #FFF;
  font-size: 12px;
  opacity: 0;
  pointer-events: none;
  transition: opacity .2s ease, transform .2s ease;
}

.bw-faq-editor__toast.is-visible { opacity: 1; transform: translate(-50%,0); }

@media (max-width: 680px) {
  .bw-profile-faq,
  .bw-faq-editor { padding: 22px; }
  .bw-faq-editor { padding-bottom: 118px; }
  .bw-faq-editor__heading { display: block; }
  .bw-faq-editor__count { margin-top: 12px; }
  .bw-faq-editor__item-head { align-items: flex-start; }
  .bw-faq-editor__actions { flex-wrap: wrap; justify-content: flex-end; }
  .bw-faq-editor__bottom-row { align-items: flex-start; flex-direction: column; }
  .bw-faq-editor__save-bar { align-items: flex-start; flex-direction: column; }
  .bw-faq-editor__save-actions { width: 100%; }
  .bw-faq-editor__button { flex: 1 1; }
}

.bw-faq-editor__drag {
  color: #87938e;
  font-size: 17px;
  letter-spacing: -2px;
  cursor: grab;
  margin-right: 6px;
  -webkit-user-select: none;
          user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/profile-faqs/faq-profile.css"],"names":[],"mappings":"AAAA;;8DAE8D;;AAE9D;;EAEE,uCAAuC;EACvC,yBAAyB;EACzB,wCAAwC;EACxC,0CAA0C;EAC1C,yCAAyC;EACzC,qDAAqD;EACrD,uDAAuD;EACvD,8CAA8C;EAC9C,0BAA0B;EAC1B,mEAAmE;EACnE,yBAAyB;EACzB,yFAAyF;EACzF,sBAAsB;AACxB;;AAEA;mBACmB,sBAAsB,EAAE;;AAE3C;;2BAE2B;AAC3B;EACE,kBAAkB;EAClB,sCAAsC;EACtC,wCAAwC;EACxC,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA,0BAA0B,wBAAwB,EAAE;;AAEpD;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,oCAAoC;EACpC,4DAA4D;AAC9D;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;AACzB;;AAEA,oDAAoD,aAAa,EAAE;;AAEnE;EACE,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;2BAE2B;AAC3B;EACE,kBAAkB;EAClB,wBAAwB;EACxB,sCAAsC;EACtC,wCAAwC;EACxC,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,iCAAiC;EACjC,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,oBAAoB;EACpB,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,oBAAoB;EACpB,iCAAiC;EACjC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,iCAAiC;EACjC,mDAAmD;AACrD;;AAEA,iCAAiC,YAAY,EAAE;AAC/C,iCAAiC,iCAAiC,EAAE;;AAEpE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,oCAAoC,YAAY,EAAE,eAAe,EAAE;;AAEnE;EACE,cAAc;EACd,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA,8CAA8C,iCAAiC,EAAE;AACjF,qDAAqD,UAAU,EAAE;;AAEjE,wBAAwB,cAAc,EAAE;AACxC,gDAAgD,gBAAgB,EAAE;;AAElE;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,aAAa;AACf;;AAEA,wBAAwB,YAAY,EAAE,eAAe,EAAE;AACvD,2BAA2B,iBAAiB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAEvG;;EAEE,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;gDACgD,iCAAiC,EAAE;;AAEnF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,wBAAwB,cAAc,EAAE;;AAExC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,uCAAuC;EACvC,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,+BAA+B,YAAY,EAAE,mBAAmB,EAAE;AAClE,wBAAwB,cAAc,EAAE,eAAe,EAAE;;AAEzD;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,iCAAiC;EACjC,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,6BAA6B,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC5E,2BAA2B,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,iCAAiC,EAAE;AAC3G,4BAA4B,eAAe,EAAE,gBAAgB,EAAE;AAC/D,2BAA2B,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AAC7E,+BAA+B,aAAa,EAAE,QAAQ,EAAE;;AAExD;EACE,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,iCAAiC;EACjC,WAAW;AACb;;AAEA,kCAAkC,YAAY,EAAE,mBAAmB,EAAE;;AAErE;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA,mCAAmC,UAAU,EAAE,4BAA4B,EAAE;;AAE7E;EACE;mBACiB,aAAa,EAAE;EAChC,iBAAiB,qBAAqB,EAAE;EACxC,0BAA0B,cAAc,EAAE;EAC1C,wBAAwB,gBAAgB,EAAE;EAC1C,4BAA4B,uBAAuB,EAAE;EACrD,0BAA0B,eAAe,EAAE,yBAAyB,EAAE;EACtE,6BAA6B,uBAAuB,EAAE,sBAAsB,EAAE;EAC9E,2BAA2B,uBAAuB,EAAE,sBAAsB,EAAE;EAC5E,+BAA+B,WAAW,EAAE;EAC5C,yBAAyB,SAAO,EAAE;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;AACnB","sourcesContent":["/* Bodhiwell · FAQ de perfil profesional\n   Componente aislado y sin dependencias.\n   Hereda los tokens del manual y declara fallbacks seguros. */\n\n.bw-profile-faq,\n.bw-faq-editor {\n  --bw-faq-bg: var(--bg-surface, #F7F5F1);\n  --bw-faq-bg-soft: #FBFAF7;\n  --bw-faq-text: var(--text-main, #13231D);\n  --bw-faq-muted: var(--text-muted, #5F726B);\n  --bw-faq-primary: var(--primary, #82B194);\n  --bw-faq-primary-hover: var(--primary-hover, #739F84);\n  --bw-faq-border: var(--border-soft, rgba(19,35,29,.08));\n  --bw-faq-card-radius: var(--radius-card, 32px);\n  --bw-faq-item-radius: 22px;\n  --bw-faq-shadow: var(--shadow-soft, 0 18px 48px rgba(18,34,29,.04));\n  color: var(--bw-faq-text);\n  font-family: \"Sora\", system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  box-sizing: border-box;\n}\n\n.bw-profile-faq *,\n.bw-faq-editor * { box-sizing: border-box; }\n\n/* =========================\n   VISTA PÚBLICA\n========================= */\n.bw-profile-faq {\n  padding: 28px 30px;\n  border: 1px solid var(--bw-faq-border);\n  border-radius: var(--bw-faq-card-radius);\n  background: var(--bw-faq-bg);\n  box-shadow: var(--bw-faq-shadow);\n}\n\n.bw-profile-faq[hidden] { display: none !important; }\n\n.bw-profile-faq__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 18px;\n}\n\n.bw-profile-faq__header > div {\n  flex: 1;\n}\n\n.bw-profile-faq__title {\n  margin: 0;\n  color: var(--bw-faq-text);\n  font-size: 30px;\n  line-height: 1.08;\n  letter-spacing: -.04em;\n  font-weight: 800;\n}\n\n.bw-profile-faq__intro {\n  margin: 7px 0 0;\n  max-width: 62ch;\n  color: var(--bw-faq-muted);\n  font-size: 13px;\n  line-height: 1.55;\n}\n\n.bw-profile-faq__edit-btn {\n  display: inline-flex;\n  align-items: center;\n  min-height: 36px;\n  padding: 0 12px;\n  border: 1px solid rgba(130,177,148,.32);\n  border-radius: 12px;\n  background: rgba(130,177,148,.09);\n  color: #315342;\n  font-size: 11px;\n  font-weight: 800;\n  text-decoration: none;\n  flex-shrink: 0;\n  transition: all 0.2s;\n}\n\n.bw-profile-faq__edit-btn:hover {\n  background: rgba(130,177,148,.16);\n  border-color: rgba(130,177,148,.45);\n}\n\n.bw-profile-faq__list {\n  display: grid;\n  gap: 9px;\n}\n\n.bw-profile-faq__item {\n  overflow: hidden;\n  border: 1px solid var(--bw-faq-border);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, .45);\n  transition: border-color .2s ease, background-color .2s ease;\n}\n\n.bw-profile-faq__item[open] {\n  border-color: rgba(130, 177, 148, .42);\n  background: rgba(130, 177, 148, .055);\n}\n\n.bw-profile-faq__question {\n  list-style: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  width: 100%;\n  padding: 16px 18px;\n  color: var(--bw-faq-text);\n  font-size: 14px;\n  font-weight: 750;\n  text-align: left;\n  border: 0;\n  background: transparent;\n}\n\n.bw-profile-faq__question::-webkit-details-marker { display: none; }\n\n.bw-profile-faq__question:focus-visible {\n  outline: 3px solid rgba(130,177,148,.25);\n  outline-offset: -3px;\n}\n\n.bw-profile-faq__icon {\n  width: 28px;\n  height: 28px;\n  flex: 0 0 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(130,177,148,.30);\n  border-radius: 50%;\n  background: transparent;\n  color: #5E806C;\n  font-size: 18px;\n  transition: transform .2s ease, background-color .2s ease, color .2s ease;\n}\n\n.bw-profile-faq__item[open] .bw-profile-faq__icon {\n  transform: rotate(45deg);\n  background: var(--bw-faq-primary);\n  color: #fff;\n  border-color: var(--bw-faq-primary);\n}\n\n.bw-profile-faq__answer { \n  display: grid;\n}\n\n.bw-profile-faq__answer p {\n  margin: 0;\n  padding: 0 58px 17px 18px;\n  max-width: 78ch;\n  color: var(--bw-faq-muted);\n  font-size: 13px;\n  line-height: 1.7;\n  white-space: pre-line;\n}\n\n/* =========================\n   EDITOR PROFESIONAL\n========================= */\n.bw-faq-editor {\n  position: relative;\n  padding: 28px 30px 104px;\n  border: 1px solid var(--bw-faq-border);\n  border-radius: var(--bw-faq-card-radius);\n  background: var(--bw-faq-bg);\n  box-shadow: var(--bw-faq-shadow);\n}\n\n.bw-faq-editor__heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 18px;\n}\n\n.bw-faq-editor__title {\n  margin: 0;\n  color: var(--bw-faq-text);\n  font-size: clamp(26px, 3vw, 36px);\n  line-height: 1.08;\n  letter-spacing: -.045em;\n  font-weight: 800;\n}\n\n.bw-faq-editor__intro {\n  margin: 9px 0 0;\n  max-width: 720px;\n  color: var(--bw-faq-muted);\n  font-size: 14px;\n  line-height: 1.7;\n}\n\n.bw-faq-editor__count {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  min-height: 30px;\n  padding: 0 10px;\n  border: 1px solid rgba(130,177,148,.26);\n  border-radius: 999px;\n  background: rgba(130,177,148,.09);\n  color: #5E806C;\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.bw-faq-editor__ideas {\n  margin-top: 22px;\n  padding: 18px 20px;\n  border: 1px solid rgba(130,177,148,.22);\n  border-radius: 18px;\n  background: rgba(130,177,148,.07);\n}\n\n.bw-faq-editor__ideas h3 {\n  margin: 0 0 8px;\n  font-size: 15px;\n}\n\n.bw-faq-editor__ideas p {\n  margin: 0 0 12px;\n  color: var(--bw-faq-muted);\n  font-size: 12px;\n  line-height: 1.6;\n}\n\n.bw-faq-editor__idea-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n\n.bw-faq-editor__idea {\n  padding: 7px 10px;\n  border: 1px solid rgba(130,177,148,.22);\n  border-radius: 999px;\n  background: rgba(255,255,255,.55);\n  color: #4D6258;\n  font-size: 11px;\n}\n\n.bw-faq-editor__list {\n  display: grid;\n  gap: 14px;\n  margin-top: 20px;\n}\n\n.bw-faq-editor__empty {\n  padding: 24px;\n  border: 1px dashed rgba(19,35,29,.16);\n  border-radius: 18px;\n  color: var(--bw-faq-muted);\n  text-align: center;\n  font-size: 13px;\n  line-height: 1.65;\n}\n\n.bw-faq-editor__item {\n  position: relative;\n  padding: 18px;\n  border: 1px solid var(--bw-faq-border);\n  border-radius: 20px;\n  background: rgba(255,255,255,.45);\n  transition: opacity .2s ease, border-color .2s ease;\n}\n\n.bw-faq-editor__item.is-hidden { opacity: .68; }\n.bw-faq-editor__item.has-error { border-color: rgba(176,78,69,.42); }\n\n.bw-faq-editor__item-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 15px;\n}\n\n.bw-faq-editor__number {\n  margin-right: auto;\n  color: #5F6E68;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.bw-faq-editor__actions {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.bw-faq-editor__icon-btn {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  border: 1px solid var(--bw-faq-border);\n  border-radius: 10px;\n  background: #FFF;\n  color: #65736D;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.bw-faq-editor__icon-btn:hover:not(:disabled),\n.bw-faq-editor__icon-btn:focus-visible {\n  border-color: rgba(130,177,148,.48);\n  color: #5E806C;\n}\n\n.bw-faq-editor__icon-btn:disabled { opacity: .35; cursor: default; }\n\n.bw-faq-editor__icon-btn--delete {\n  color: #C95C5C;\n  background: #FEF2F2;\n  border: 1px solid rgba(201, 92, 92, 0.4);\n}\n\n.bw-faq-editor__icon-btn--delete:hover:not(:disabled),\n.bw-faq-editor__icon-btn--delete:focus-visible {\n  background: #C95C5C;\n  color: #fff;\n  border-color: transparent;\n}\n\n.bw-faq-editor__toggle-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  color: #5A6B64;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.bw-faq-editor__switch {\n  position: relative;\n  width: 36px;\n  height: 20px;\n  padding: 0;\n  border: 0;\n  border-radius: 999px;\n  background: #CFD7D2;\n  cursor: pointer;\n}\n\n.bw-faq-editor__switch::after {\n  content: \"\";\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: #FFF;\n  box-shadow: 0 1px 4px rgba(0,0,0,.15);\n  transition: left .2s ease;\n}\n\n.bw-faq-editor__switch[aria-checked=\"true\"] { background: var(--bw-faq-primary); }\n.bw-faq-editor__switch[aria-checked=\"true\"]::after { left: 19px; }\n\n.bw-faq-editor__field { display: block; }\n.bw-faq-editor__field + .bw-faq-editor__field { margin-top: 14px; }\n\n.bw-faq-editor__label {\n  display: block;\n  margin-bottom: 7px;\n  color: #6D7C75;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: .08em;\n  text-transform: uppercase;\n}\n\n.bw-faq-editor__input,\n.bw-faq-editor__textarea {\n  display: block;\n  width: 100%;\n  border: 1px solid rgba(19,35,29,.10);\n  border-radius: 13px;\n  background: #FFF;\n  color: var(--bw-faq-text);\n  outline: none;\n  font: inherit;\n}\n\n.bw-faq-editor__input { height: 44px; padding: 0 13px; }\n.bw-faq-editor__textarea { min-height: 112px; padding: 12px 13px; resize: vertical; line-height: 1.55; }\n\n.bw-faq-editor__input:focus,\n.bw-faq-editor__textarea:focus {\n  border-color: rgba(130,177,148,.62);\n  box-shadow: 0 0 0 3px rgba(130,177,148,.10);\n}\n\n.bw-faq-editor__input[aria-invalid=\"true\"],\n.bw-faq-editor__textarea[aria-invalid=\"true\"] { border-color: rgba(176,78,69,.52); }\n\n.bw-faq-editor__field-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 6px;\n  color: #8B9691;\n  font-size: 10px;\n}\n\n.bw-faq-editor__error { color: #A6534B; }\n\n.bw-faq-editor__bottom-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 16px;\n}\n\n.bw-faq-editor__add {\n  min-height: 42px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 0 16px;\n  border: 1px solid rgba(130,177,148,.42);\n  border-radius: 13px;\n  background: rgba(130,177,148,.10);\n  color: #315442;\n  font-size: 13px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.bw-faq-editor__add:disabled { opacity: .45; cursor: not-allowed; }\n.bw-faq-editor__limit { color: #7A8882; font-size: 11px; }\n\n.bw-faq-editor__save-wrap {\n  position: absolute;\n  left: 22px;\n  right: 22px;\n  bottom: 18px;\n}\n\n.bw-faq-editor__save-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 13px 14px;\n  border: 1px solid var(--bw-faq-border);\n  border-radius: 18px;\n  background: rgba(247,245,241,.96);\n  box-shadow: 0 12px 32px rgba(19,35,29,.10);\n  backdrop-filter: blur(10px);\n}\n\n.bw-faq-editor__save-state { display: flex; align-items: center; gap: 10px; }\n.bw-faq-editor__save-dot { width: 9px; height: 9px; border-radius: 50%; background: var(--bw-faq-primary); }\n.bw-faq-editor__save-copy { font-size: 12px; font-weight: 800; }\n.bw-faq-editor__save-sub { margin-top: 2px; color: #718079; font-size: 10px; }\n.bw-faq-editor__save-actions { display: flex; gap: 8px; }\n\n.bw-faq-editor__button {\n  min-height: 38px;\n  padding: 0 16px;\n  border: 1px solid rgba(130,177,148,.34);\n  border-radius: 12px;\n  background: #FFF;\n  color: var(--bw-faq-text);\n  font-size: 12px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.bw-faq-editor__button--primary {\n  min-width: 118px;\n  border-color: var(--bw-faq-primary);\n  background: var(--bw-faq-primary);\n  color: #FFF;\n}\n\n.bw-faq-editor__button:disabled { opacity: .48; cursor: not-allowed; }\n\n.bw-faq-editor__toast {\n  position: fixed;\n  left: 50%;\n  bottom: 24px;\n  z-index: 100;\n  transform: translate(-50%,20px);\n  padding: 11px 16px;\n  border-radius: 12px;\n  background: #13231D;\n  color: #FFF;\n  font-size: 12px;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity .2s ease, transform .2s ease;\n}\n\n.bw-faq-editor__toast.is-visible { opacity: 1; transform: translate(-50%,0); }\n\n@media (max-width: 680px) {\n  .bw-profile-faq,\n  .bw-faq-editor { padding: 22px; }\n  .bw-faq-editor { padding-bottom: 118px; }\n  .bw-faq-editor__heading { display: block; }\n  .bw-faq-editor__count { margin-top: 12px; }\n  .bw-faq-editor__item-head { align-items: flex-start; }\n  .bw-faq-editor__actions { flex-wrap: wrap; justify-content: flex-end; }\n  .bw-faq-editor__bottom-row { align-items: flex-start; flex-direction: column; }\n  .bw-faq-editor__save-bar { align-items: flex-start; flex-direction: column; }\n  .bw-faq-editor__save-actions { width: 100%; }\n  .bw-faq-editor__button { flex: 1; }\n}\n\n.bw-faq-editor__drag {\n  color: #87938e;\n  font-size: 17px;\n  letter-spacing: -2px;\n  cursor: grab;\n  margin-right: 6px;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
